import React from "react";
import { withStyles } from "@material-ui/core/styles";
import defaultToolbarSelectStyles from "./styles";

class CustomToolbarSelect extends React.Component {

  handleRemover() {
    this.props.params.handleClickOpen();
    this.props.params.setState({propsToolbarSelected: this.props});
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.iconContainer}></div>
    );
  };

};

export default withStyles(
  defaultToolbarSelectStyles,
  { name: "CustomToolbarSelect" }
)(CustomToolbarSelect);
